import { IInstitutionConfiguration } from '../../interfaces/institution/institution-configuration.interface';
import { IInstitution } from '../../interfaces/institution/institution.interface';

export abstract class AbstractInstitutionService {
  abstract getInformation(): Promise<IInstitution | undefined>;
  abstract getConfiguration(): Promise<IInstitutionConfiguration | undefined>;
}
